$("a").attr('title', '');

if($('#ContactForm-notifyMe').length){
    $('.product-form__buttons').on('click', (e) => {
        var $target = $(e.target);
        if($('.productView-action input').attr('value') != ''){
            $('.productView-buttons').addClass('show-input');
        }
    })
}

if($('body.notify-me-show').length){
    $('.product-details .product-form__buttons.no-variant .button').text('You are all set!');
}

if($('#halo-product-bundle').length){

    $( "body" ).on( "click", (e) => {
        if(e.target.classList.contains('bg-overflow')){
           $('body.show-popup-bundle .bundle-product-item.is-open').removeClass('is-open'); 
        }
        
        if($('.product-details .bundle-product-item.is-open').length){
            document.body.classList.add('show-popup-bundle');
        } else{
            document.body.classList.remove('show-popup-bundle');
        }
    } );
    
    $( "[add-bundle]" ).on( "click", (e) => {
        var $target = $(e.target),
            productID = $target.data('product-id');
        $('[for="bundle-product-item-'+productID+'"]').trigger( "click" );
        changeSelect(productID);
    });
    
    $('.bundle-option-content .button-select').on( "click", (e) => {
        var $target = $(e.target),
            productID = $target.data('product-id');
        $('[data-product-option-id="'+productID+'"] .bundle-option-close').trigger( "click" );
        $('[for="bundle-product-item-'+productID+'"]').trigger( "click" );
        changeSelect(productID);
    });
    
    $('.bundle-product-toogle:not([add-bundle])').on( "click", (e) => {
        var $target = $(e.target),
            productID = $target.data('product-id');
        if($target.hasClass('selected')){
            $('[for="bundle-product-item-'+productID+'"]').trigger( "click" );
            changeSelect(productID);
        }
    });
    
    function changeSelect(productID) {
       setTimeout(() => {
            if($('.bundle-product-item.isChecked[data-bundle-product-item-id="'+productID+'"]').length){
                $('.bundle-product-item.isChecked[data-bundle-product-item-id="'+productID+'"] .bundle-product-toogle').text('Selected');
                $('.bundle-product-item.isChecked[data-bundle-product-item-id="'+productID+'"] .bundle-product-toogle').addClass('selected');
            } else{
                $('.bundle-product-item[data-bundle-product-item-id="'+productID+'"] .bundle-product-toogle').text('Select');
                $('.bundle-product-item[data-bundle-product-item-id="'+productID+'"] .bundle-product-toogle').removeClass('selected');
            } 
        }, 100)
    }
    
    function getPopupPosition() {
      const buttonCard = document.querySelectorAll(".bundle-product-toogle"),
            productBlock = document.querySelector("#halo-product-bundle");
          
      if(!buttonCard || !productBlock) return;
    
      let vh = Math.max(document.documentElement.clientHeight || 0, window.innerHeight || 0);
      
      for (let button of buttonCard) {
        button.addEventListener('click', (e) => {
          if(!$(e.target).hasClass('selected')){
              setTimeout(() => {
                const popup = document.querySelector(".is-open .bundle-product-options.halo-popup");
        
                  const {top, left, bottom} = popup.getBoundingClientRect();
        
                  const popupHeight = popup.clientHeight;
        
                  const bottomDistance = (vh - popupHeight) / 2;
        
                  const transformPosition = (bottomDistance - top) / 4;
        
                window.scrollTo({ top: (productBlock.offsetTop + 85 - bottomDistance), behavior: 'smooth'});
        
                popup.style.top = '0';
                popup.style.transform = `unset`;
          
              }, 500)
          }
        })
      }
    }
    getPopupPosition();
    
}


